import styled from 'styled-components';
import { theme } from '@frameio/vapor';

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  height: 100%;
  min-width: 0;

  svg {
    margin-right: ${theme.spaces[8]};
  }
`;
